import React from 'react';
import { useEffect, useState } from 'react';
import Goal from './wrappers/Goal';
import SuggestedCharge from './wrappers/SuggestedCharge';
import TotalSpends from './wrappers/TotalSpends';
import ClientsDemography from './wrappers/ClientsDemography';
import ClientSourcing from './wrappers/ClientSourcing';
import ClientsGender from './wrappers/ClientsGender';
import GeneralInfo from './wrappers/GeneralInfo';
import i18n from './i18n';
import Title from './styled/Title';
import { GridCol, Grid } from './styled/Grid';
import styled from 'styled-components';

const Wrapper = styled(Grid)`
  padding-top: 55px;
`

const DashboardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const topGoalsList = [
  {
    name: 'clientsGoal',
    title: i18n.t('clientsGoal.title'),
  },
  {
    name: 'incomeGoal',
    title: i18n.t('incomeGoal.title'),
  },
  {
    name: 'workingHours',
    title: i18n.t('workingHours.title'),
  },
  {
    name: 'currentSpends',
    title: i18n.t('currentSpends.title'),
  },
]

const Main = (props) => {
  const { userName, language, settingId } = props;
  const [data, setData] = useState(null);

  useEffect(() => {
    i18n.changeLanguage(language);
    fetch('/load_dashboard_data', {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => response.json())
      .then(({ data: apiData }) => {
        setData(JSON.parse(apiData));
      });
  }, [setData]);

  return data && (
    <Wrapper>
      <GridCol $columns={12}>
        <DashboardHead>
          <Title>{i18n.t('greeting', { userName })}</Title>
          <a href={`/dashboard_settings/${settingId}/edit`}>{i18n.t('configureDashboard')}</a>
        </DashboardHead>
      </GridCol>
      {topGoalsList.map(item => (
        <GridCol
          $columns={3}
          key={item.name}
        >
          <Goal data={data} name={item.name} title={item.title} />
        </GridCol>  
      ))}
      <GridCol $columns={6}>
        <SuggestedCharge data={data} />
      </GridCol>
      <GridCol $columns={6}>
        <TotalSpends data={data} />
      </GridCol>
      <GridCol $columns={6}>
        <ClientsDemography data={data} />
      </GridCol>
      <GridCol $columns={6}>
        <ClientSourcing data={data} />
      </GridCol>
      <GridCol $columns={12}>
        <ClientsGender data={data} />
      </GridCol>
      <GridCol $columns={12}>
        <GeneralInfo data={data} />
      </GridCol>
    </Wrapper>
  );
};

export default Main;
